export const randomDate = (): Date => (
	new Date(2022, Math.random() * 12, Math.random() * 28)
);
